module.exports = __webpack_public_path__ + "media/images/front/life_style/4-a5920cdea3495f2a7904094384e9d8d3.jpg";